const paymentMethods = {
  SUBSCRIPTION: "Subscription",
  UNKNOWN: "unknown",
};

export default paymentMethods;



// WEBPACK FOOTER //
// ./src/common/subscriptionmanagement/paymentMethods.js